export default __webpack_public_path__ + "static/media/warning.ecacdf56.svg";